import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DesignModuleCard from './DesignModuleCard';
import { LibraryBooks as LibraryIcon } from '@mui/icons-material';

// Import all icons - reimporting to refresh the updated icons
import steelBeamIcon from '../assets/Steel Beam.png?v=2';
import steelColumnIcon from '../assets/Steel Column.png?v=2';
import steelConnectionIcon from '../assets/Steel Connection.png?v=2';
import concreteBeamIcon from '../assets/Concrete Beam.png';
import concreteColumnIcon from '../assets/Concrete Column.png';
import padFootingIcon from '../assets/Pad footing.png?v=2';
import pileCapIcon from '../assets/Pile Cap.png?v=2';
import baseplateIcon from '../assets/Baseplate.png?v=2';

const moduleCategories = {
  steel: [
    { 
      title: 'Steel Beam', 
      icon: <img src={steelBeamIcon} alt="Steel Beam" />,
      path: '/beam-design' 
    },
    { 
      title: 'Steel Column', 
      icon: <img src={steelColumnIcon} alt="Steel Column" />,
      path: '/column-design' 
    },
    { 
      title: 'Steel Connection', 
      icon: <img src={steelConnectionIcon} alt="Steel Connection" />,
      path: '/connection-design' 
    },
  ],
  concrete: [
    { 
      title: 'Concrete Beam', 
      icon: <img src={concreteBeamIcon} alt="Concrete Beam" />,
      path: '/concrete-beam-design' 
    },
    { 
      title: 'Concrete Column', 
      icon: <img src={concreteColumnIcon} alt="Concrete Column" />,
      path: '/concrete-column-design' 
    },
  ],
  foundation: [
    { 
      title: 'Pad Footing', 
      icon: <img src={padFootingIcon} alt="Pad Footing" />,
      path: '/pad-footing-design' 
    },
    { 
      title: 'Pile Cap', 
      icon: <img src={pileCapIcon} alt="Pile Cap" />,
      path: '/pile-cap-design' 
    },
    { 
      title: 'Baseplate', 
      icon: <img src={baseplateIcon} alt="Baseplate" />,
      path: '/baseplate-design' 
    },
  ],
  sectionLibrary: [
    { 
      title: 'Section Library', 
      icon: <LibraryIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      path: '/section-library' 
    },
  ],
};

const DesignModuleGrid = () => {
  const navigate = useNavigate();

  const handleModuleClick = (category, module) => {
    // Check if user is on the homepage or engineering tools page
    const currentPath = window.location.pathname;
    
    if (currentPath === '/' || currentPath === '/engineering-tools') {
      // If user is not authenticated, redirect to sign in
      navigate('/signin');
      return;
    }
    
    // If user is on dashboard or other authenticated pages, navigate to the specific module
    navigate(module.path);
  };

  return (
    <Container maxWidth="lg">
      {Object.entries(moduleCategories).map(([category, modules]) => (
        <Box key={category} sx={{ mb: 8 }}>
          <Typography
            variant="h4"
            sx={{
              textTransform: 'uppercase',
              mb: 4,
              fontWeight: 'bold',
              letterSpacing: 1,
            }}
          >
            {category} MEMBER DESIGN
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 3,
              justifyContent: 'flex-start',
            }}
          >
            {modules.map((module) => (
              <DesignModuleCard
                key={module.title}
                title={module.title}
                icon={module.icon}
                onClick={() => handleModuleClick(category, module)}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Container>
  );
};

export default DesignModuleGrid; 